import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {Assignment} from '@features/assignment/types.ts'
import {QUERY_KEYS} from '@/queryClient.ts'
import {raise} from '@utilities/helpers.ts'
import {httpGetAssignment} from '@features/assignment/http/assignment.http'
import {captureException} from '@sentry/react'
import {parseAxiosPromise} from '@/axiosInstance.ts'

export const useAssignment = (code?: number, options?: Omit<UseQueryOptions<Assignment>, 'queryFn' | 'queryKey'>) =>
    useQuery({
        queryKey: [QUERY_KEYS.ASSIGNMENT, code],
        queryFn: () =>
            parseAxiosPromise({
                axiosPromise: httpGetAssignment({
                    urlParams: {assignmentCode: code ?? raise('The code is not provided')},
                    params: {response_type: 'extended'}
                }),
                responseShape: Assignment,
                onZodError: captureException
            }),
        ...options
    })
